var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLastAccessControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11967",
    "data-name": "Group 11967",
    transform: "translate(-636.434 -236.959)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(636.434 236.959)",
    fill: "#f4f8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "security_black_24dp",
    transform: "translate(650.434 251.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    d: "M0,0H66.75V66.75H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M26.477,1,3,11.937v16.4c0,15.175,10.017,29.365,23.477,32.81,13.46-3.445,23.477-17.635,23.477-32.81v-16.4Zm0,30.048h18.26c-1.383,11.265-8.556,21.3-18.26,24.443V31.076H8.217V15.491l18.26-8.5Z",
    transform: "translate(6.898 2.299)",
    fill: "#107a98"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastAccessControl);
export default __webpack_public_path__ + "static/media/lastAccessControl.23ea8a7678a344794ec9fe6d41f4a860.svg";
export { ForwardRef as ReactComponent };